import { JOB_TITLES } from '@account/constants';
import { AccountDetailsFormValues } from '@account/types';
import { Roles } from '@common/types/user';
import { InputField } from '@components/utility/inputs';
import { Select } from '@components/utility/selects';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';

export const CompanyInformation = ({ loading }: { loading?: boolean }) => {
    //#region Hooks
    const intl = useIntl();
    const { values, errors, touched, handleChange } = useFormikContext<AccountDetailsFormValues>();
    //#endregion

    //#region Processed Data
    const jobTitleOptions = JOB_TITLES(intl);
    //#endregion

    return (
        <>
            <InputField
                id="company_name"
                name="company_name"
                buffered
                placeholder={intl.formatMessage({
                    id: 'common.company.placeholder',
                    defaultMessage: 'Enter company name',
                })}
                fullWidth
                required={values.role === Roles.INSTALLER}
                topLabel={intl.formatMessage({ id: 'common.company', defaultMessage: 'Company' })}
                debounceMs={0}
                boxProps={{
                    className: 'md:col-span-2',
                }}
                loading={loading}
            />
            <Select
                id="job_title"
                items={jobTitleOptions}
                type="radio"
                placeholder={intl.formatMessage({
                    id: 'common.jobTitle.placeholder',
                    defaultMessage: 'Choose job title',
                })}
                size="smallest"
                topLabel={intl.formatMessage({ id: 'common.jobTitle', defaultMessage: 'Job Title' })}
                name="job_title"
                value={values.job_title ?? ''}
                error={touched.job_title && !!errors.job_title}
                helperText={touched.job_title && errors.job_title ? errors.job_title : undefined}
                onChange={handleChange}
                fullWidth
                boxProps={{
                    className: 'md:col-span-2 w-full',
                }}
                loading={loading}
                loadingType="skeleton"
            />
            <InputField
                id="job_title_other"
                name="job_title_other"
                buffered
                placeholder={intl.formatMessage({
                    id: 'common.jobTitleOther.placeholder',
                    defaultMessage: 'Enter your job title',
                })}
                fullWidth
                topLabel={intl.formatMessage({ id: 'common.jobTitleOther', defaultMessage: 'Custom Job Title' })}
                debounceMs={0}
                boxProps={{
                    className: 'md:col-span-2',
                }}
                disabled={values.job_title !== 'other'}
                required={values.job_title === 'other'}
                loading={loading}
            />
        </>
    );
};
